import { render, staticRenderFns } from "./PartiesList.vue?vue&type=template&id=6065b69d&"
import script from "./PartiesList.vue?vue&type=script&lang=js&"
export * from "./PartiesList.vue?vue&type=script&lang=js&"
import style0 from "./PartiesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports